<template>
	<div class="poi poi-main" v-if="poi">
        <div class="poi-content flex flex-col">
            <div class="poi-background" v-show="shopPhoto" :style="{'background-image': 'url(' + shopPhoto + ')'}">
            </div>
            <div class="poi-header">
                <h2 class="poi-name" v-html="poi.getName(language) || ''"></h2>
                <div class="poi-logo poi-logo-holder"><img :src="shopLogo" v-show="shopLogo"/></div>
                <div class="poi-qr" v-if="poi.web">
                    <div class="poi-qr-code" v-html="qrWeb"></div>
                    <WFTranslate l="web">Web</WFTranslate>
                </div>
            </div>
            <div class="poi-header2">
                <div class="poi-opening_hours">
                    <WFIcon name="clock" v-show="!!poi.getOpeningHours(language)"></WFIcon>
                    <span v-html="poi.getOpeningHours(language) || ''"></span>
                </div>
                <button class="btn btn-border btn-lg" @click="showPath"><WFIcon name="path"/><WFTranslate k="show_path">Show path</WFTranslate></button>
            </div>
            <div class="poi-description" v-html="poi.getDescription(language) || ''"></div>
        </div>
        <div class="poi-footer" v-if="hasCustomer">
            <h2><WFTranslate k="customer_service"></WFTranslate></h2>
            <div class="poi-footer-content">
                <div class="poi-phone" v-if="poi.phone !== ''"><WFIcon name="phone"/><label>{{poi.phone}}</label></div>
                <div class="poi-email" v-if="poi.email !== ''"><WFIcon name="email"/><label>{{poi.email}}</label></div>
            </div>
        </div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
const QRCode = require("qrcode-svg");
import { WFTranslate } from '@3dwayfinder/wayfinder-vue-components'

export default {
	name: "POI",
    components: {
        WFTranslate
    },
	computed: {
		...mapState('wf', ['language']),
		hasShowPathListener(){
			return !!(this.$listeners && this.$listeners.showPath);
		},
        hasCustomer () {
            return (this.poi.phone != null && this.poi.phone !== '') || (this.poi.email !== null && this.poi.email !== '');
        }
	},
	props: {
		poi: {
			type: Object,
			default: null
		},
		showLogo: {
			type: Boolean,
			default: false
		},
		showName: {
			type: Boolean,
			default: true
		},
		showPathButton: {
			type: Boolean,
			default: false
		},
		showDescription: {
			type: Boolean,
			default: false
		},
		showRoomID: {
			type: Boolean,
			default: false
		},
		showFloor: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		language () {
			if (this.$wayfinder) {
				this.show_path = this.$wayfinder.translator.get('show_path');
			}
		},
        poi () {
            if(this.poi) {
                this.shopLogo = this.poi.getIconUrl();
                this.shopPhoto = this.poi.getBackgroundUrl();    
                if(this.poi.web) {
                    this.qrWeb = new QRCode({content: this.poi.web, container: "svg-viewbox", padding: 2}).svg();
                }
                else {
                    this.qrWeb = "";
                }
            }
            else {
                this.shopLogo = "";
                this.shopPhoto = "";
                this.qrWeb = "";
            }
           
        }
	},
	methods: {
		showPath () {
			if (this.poi) {
				if (this.hasShowPathListener) {
					this.$emit('showPath', this.poi);
				}
				else {
					this.$wayfinder.showPath(this.poi.getNode(), this.poi);
				}
			}
		},
        showOnMap () {
            this.$emit('showOnMap', this.poi);
        },
		open (type) {
			if (type && this.poi[type]) {
				if (type === 'shop_email') {
					window.open('mailto:' + this.poi[type], '_system')
				}
				else if (type === 'shop_phone') {
					window.open('tel:' + this.poi[type], '_system')
				}
				else {
					window.open(this.poi[type], '_system')
				}
			}
		},
        close () {
            this.$emit('close');
        },
		getImage () {
            if (!this.poi)
                return '';

			if (this.poi.getBackgroundUrl())
				return 'url("' + this.poi.getBackgroundUrl() + '")';
				
			else if (this.poi.getIconUrl()) {
				return 'url("' + this.poi.getIconUrl() + '")';
			}
			else {
				return false;
			}
		},
		isImage () {
			if(this.poi.getBackgroundUrl()) return "image-background";
			else if (this.poi.getIconUrl()) return "image-logo";
			else return "image-none";
		},
		truncate (str, len) {
			if (str && str.length > len) {
				return str.substring(0, len) + '...';
			}
			else {
				return str;
			}
		}
	},
	data: function () {
		return {
			show_path: 'Show Path',
            shopLogo: '',
            shopPhoto: '',
            qrWeb: ''
		}
	}
};
</script>

<style lang="less">
    @import '../css/variables';
    
    .poi-main {
        padding-bottom: 6.4rem;

        .poi-background {
            flex-basis: 18.1rem;
            width: 100%;
            border-radius: @border-radius;
            background-position: 50%;
            background-size: cover;
            background-repeat: no-repeat;
            flex-grow: 0;
            flex-shrink: 1;
            overflow: hidden;
            transition: background-image 0.3s ease-in 0s;

            img {
                object-fit: cover;
                width: 100%;
            }
        }
        .poi {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            overflow: hidden;
        }

        .poi-logo-holder {
            height: 8.6rem;
            min-width: 7.2rem;
            max-width: 21.6rem;
            overflow: hidden;

            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
            }
        }

        .poi-qr {
            background-color: #000;
            border-radius: @border-radius;
            color: #fff;
            display: flex;
            flex-direction: column;
            padding: 0.6rem;
            margin-left: 2rem;

            svg {
                height: 8rem;
                width: 8rem;
            }

            label {
                margin-top: 0.6rem;
                font-size: 1.2rem;
                font-weight: 400;
            }
        }

        .poi-header {
            font-size: 1.4rem;
            display: flex;
            flex-basis: 5.6rem;
            flex-grow: 0;
            flex-shrink: 0;
            padding: 2.4rem 0;
            align-items: flex-start;
            border-bottom: @border-thickness solid var(--th-primary);

            .poi-name {
                flex-grow: 1;
                padding-right: 1rem;
            }

            .poi-qr {
                display: flex;
                line-height: 1.4rem;
                align-items: center;

                .icon {
                    height: 1.4rem;
                    margin-right: 0.8rem;

                    --color1: rgba(167, 169, 172, 1);

                }

                & > * {
                    display: flex;
                    align-items: center;
                }
            }
        }

        .poi-header2 {
            display: flex;
            padding: 2.4rem 0;
            justify-content: space-between;
        }

        .poi-opening_hours {
            display: flex;

            svg, .wf-icon {
                fill: var(--th-primary);
                --icon_color: var(--th-primary);
                width: 1.6rem;
                height: 1.6rem;
                margin-right: 0.8rem;
                margin-top: 0.4rem;
            }
        }

        .poi-name {
            font-size: 3.2rem;
            font-weight: bold;
            line-height: 1.2;
        }

        .poi-description {
            margin: 1.6rem 0;
            font-size: 2rem;
        }

        .poi-content {
            flex-grow: 1;
            flex-shrink: 1;
            display: flex;
            padding-bottom: 1.4rem;
            font-size: 2rem;
            line-height: 2.4rem;
            overflow: hidden;

            .poi-content-left {
                font-size: 1.8rem;
                display: flex;
                flex-direction: column;
                padding-right: 2rem;
                margin-right: 1rem;
                flex-grow: 0;
                flex-shrink: 1;
            }

            .poi-content-right {
                width: 23.8rem;
                display: flex;
                flex-direction: column;
                height: 100%;

                .btn {
                    width: 100%;
                    justify-content: center;
                }

                .poi-buttons img {
                    height: 4.8rem;
                    width: 100%;
                    object-fit: contain;
                    
                }
            }

            .img-placeholder {
                width: 23.8rem;
                height: 23.8rem;

                img {
                    width: 23.8rem;
                    height: 23.8rem;
                    object-fit: cover;
                }
            }
        }

        .poi-footer {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex-basis: 6.4rem;
            flex-grow: 0;
            flex-shrink: 0;
            font-size: 1.4rem;

            .poi-phone {
                margin-right: 3.4rem !important;
                display: flex;
                align-content: center;
                
                svg, .wf-icon, .icon {
                    fill: var(--th-primary) !important;
                    stroke: var(--th-primary) !important;
                    color: var(--th-primary) !important;
                    --icon_color: var(--th-primary) !important;
                    --color1: var(--th-primary) !important;
                    --fill: var(--th-primary) !important;
                }
            }
            
            .poi-email {
                margin-right: 3.4rem !important;
                display: flex;
                align-content: center;
                
                svg, .wf-icon, .icon {
                    fill: var(--th-primary) !important;
                    stroke: var(--th-primary) !important;
                    color: var(--th-primary) !important;
                    --icon_color: var(--th-primary) !important;
                    --color1: var(--th-primary) !important;
                    --fill: var(--th-primary) !important;
                }
            }

            .icon {
                height: 1.6rem !important;
                font-weight: 500;
                margin-top: 0.2rem;
                margin-right: 0.6rem;
            }

            .poi-footer-right {
                justify-content: flex-end;
                flex-grow: 1;
                margin-right: -1.5rem;
            }

            & > div {
                display: flex;
                align-items: center;

                & > * {
                    display: flex;
                    align-items: center;
                    
                }
            }

            .btn {
                width: 50%;
                justify-content: center;
            }

            .poi-footer-content {
                margin-top: 1.6rem;
                
                label {
                    margin-top: 0.4em;
                }
            }

            .poi-email .icon {
                margin-top: 0.2em;
            }
        }
    }
</style>